<template>
  <div id="titles_container" class="relative h-[220px] sm:h-[130px]">
    <!-- Слайд 1 (активный по умолчанию) -->
    <div class="flex flex-col flex-wrap justify-center title-item active" data-slide="0">
      <div class="flex flex-wrap justify-center lg:gap-4 banner-title font-bold text-[32px] lg:text-3xl text-center leading-tight lg:leading-[64px]">
        <div class="font-inter">Transform<br class="lg:hidden"> Your Assets Into</div>
        <div class="font-inter bg-clip-text bg-gradient-to-r from-[#E781FF] to-[#A72E69] text-transparent">
          Digital Wealth
        </div>
      </div>
      <div class="banner-desc lg:flex flex-col text-center mt-4 leading-tight">
        <span class="text-sm lg:text-xl">Experience the future of asset management with STIMA iOS app. </span>
        <span class="text-sm lg:text-xl">Seamlessly bridge the gap between physical luxury and digital innovation.</span>
      </div>
    </div>

    <!-- Слайд 4 -->
    <div class="flex flex-col flex-wrap justify-center title-item" data-slide="4">
      <div class="flex flex-col flex-wrap justify-center lg:gap-4 banner-title font-inter font-bold text-[32px] lg:text-3xl text-center lg:leading-[64px]">
        <div>Get The Latest<br class="lg:hidden"> Version of</div>
        <div class="font-inter bg-clip-text bg-gradient-to-r from-[#E781FF] to-[#A72E69] text-transparent uppercase">
          stima
        </div>
      </div>
      <div class="banner-desc flex flex-col text-center mt-4">
        <span class="text-sm lg:text-xl">STIMA App is now available in App Store</span>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>